import { render, staticRenderFns } from "./batchMatchingResults.vue?vue&type=template&id=4996ec39&scoped=true"
import script from "./batchMatchingResults.vue?vue&type=script&lang=js"
export * from "./batchMatchingResults.vue?vue&type=script&lang=js"
import style0 from "./batchMatchingResults.vue?vue&type=style&index=0&id=4996ec39&prod&lang=scss&scoped=true"
import style1 from "./batchMatchingResults.vue?vue&type=style&index=1&id=4996ec39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996ec39",
  null
  
)

export default component.exports